import { toastr } from "react-redux-toastr";
import { client } from "utils/api";

const uploadProductImagesWithFlags = async ({ product_id, files, flags = {} }) => {
  await Promise.all(
    files.map(async (image) => {
      const body = new FormData();
      body.append("image", image);
      body.append("product_id", product_id);
      if (flags.is_generated_by_ai) {
        body.append("is_generated_by_ai", "true");
      }
      await client.post(`/product_images/`, body, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    })
  );
};

export const uploadProductImages = async ({ product_id, files }) => {
  try {
    await uploadProductImagesWithFlags({ product_id, files });
    toastr.success(
      "Sukces",
      files.length > 1 ? "Zdjęcia zostały dodane" : "Zdjęcie zostało dodane"
    );
  } catch (error) {
    toastr.error(
      "Błąd",
      files.length > 1
        ? "Wystąpił błąd podczas wgrywania zdjęć"
        : "Wystąpił błąd podczas wgrywania zdjęcia"
    );

    throw new Error(error.response?.data?.error);
  }
};

export const uploadProductAiImages = async ({ product_id, files }) => {
  try {
    await uploadProductImagesWithFlags({
      product_id,
      files,
      flags: { is_generated_by_ai: true },
    });
    toastr.success(
      "Sukces",
      files.length > 1
        ? "Zdjęcia AI zostały dodane"
        : "Zdjęcie AI zostało dodane"
    );
  } catch (error) {
    toastr.error(
      "Błąd",
      files.length > 1
        ? "Wystąpił błąd podczas wgrywania zdjęć AI"
        : "Wystąpił błąd podczas wgrywania zdjęcia AI"
    );

    throw new Error(error.response?.data?.error);
  }
};

export const removeProductImage = (id, data) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    await client
      .put(`/product_images/${id}`, data)
      .then(({ data }) => {
        resolve();
      })
      .catch((err) => {
        reject(err.response.data.error);
      });
  });
};

export const updateProductImage = async (id, image) => {
  try {
    const body = new FormData();
    body.append("image", image);
    await client.put(`/product_images/${id}`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toastr.success("Sukces", "Zdjęcie zostało zmienione");
  } catch (error) {
    toastr.error("Błąd", "Nie udało się zmienić zdjęcia");
    throw new Error(error.response?.data?.error);
  }
};

export const deleteProductImages = async (ids) => {
  try {
    await Promise.all(ids.map((id) => client.delete(`/product_images/${id}`)));
    toastr.success(
      "Sukces",
      ids.length > 1 ? "Zdjęcia zostały usuniete" : "Zdjęcie zostało usuniete"
    );
  } catch (error) {
    toastr.error(
      "Błąd",
      ids.length > 1
        ? "Wystąpił błąd podczas usuwania zdjęć"
        : "Wystąpił błąd podczas usuwania zdjęcia"
    );
    throw new Error(error.response?.data?.error);
  }
};

export const setProductGlobalImage = async (id) => {
  try {
    await client.post(`/product_images/${id}/mark_as_global`);
    toastr.success("Sukces", "Zdjęcie globalne zostało zmienione");
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd");
    throw new Error(error.response?.data?.error);
  }
};

export const setProductNeutralImage = async (id, is_neutral) => {
  try {
    await client.put(`/product_images/${id}`, {
      is_neutral,
    });
    toastr.success("Sukces", "Zdjęcie neutralne zostało zaktualizowane");
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd");
    throw new Error(error.response?.data?.error);
  }
};

export const setProductForBundleImage = async (id, is_for_bundle) => {
  try {
    await client.put(`/product_images/${id}`, {
      is_for_bundle,
    });
    toastr.success("Sukces", "Zdjęcie dla bundla zostało zaktualizowane");
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd");
    throw new Error(error.response?.data?.error);
  }
};

export const setProductAiImage = async (id, is_generated_by_ai) => {
  try {
    await client.put(`/product_images/${id}`, {
      is_generated_by_ai,
    });
    toastr.success("Sukces", "Oznaczenie AI zostało zaktualizowane");
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd");
    throw new Error(error.response?.data?.error);
  }
};

export const renameProductImage = async (id, file_name) => {
  try {
    await client.put(`/product_images/${id}/rename`, {
      file_name,
    });
    toastr.success("Sukces", "Nazwa pliku została zmieniona");
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd");
    throw new Error(error.response?.data?.error);
  }
};
